module.exports = __webpack_public_path__ + "assets/img/张飞.6581f4a0.jpg";